export default "__VITE_PUBLIC_ASSET__d302bf09__"